/*
 * @Author: zhoupeng 
 * @Date: 2018-09-15 13:57:15 
 * @Last Modified by: Michael
 * @Last Modified time: 2019-09-17 10:51:42
 */

<template>
  <div class="xm-audio" @click.stop="handlePlayAudio" :style="{width:2+(4*size/1000)/60+'rem'}">
    <audio :src="voiceSrc" ref="audio"></audio>
    <img class="voice" id="voice" :src="voice[voiceNum]" />
    <span class="voice-time" v-if="time">{{time}}&nbsp;"</span>
  </div>
</template>

<script>
import voice0 from "@/images/voice0.png";
import voice1 from "@/images/voice1.png";
import voice2 from "@/images/voice2.png";
import VideoUpload from "@/service/UploaderService";

export default {
  name: "xm-audio",
  props: {
    audioSrc: {
      type: String,
      required: true
    },
    size: {
      type: [Number,String],
      required: true
    },
    handleClick: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  components: {
    //Example
  },

  data() {
    return {
      voice: [voice0, voice1, voice2],
      voiceNum: 2,
      voiceTime: null,
      audio: null,
      time: 0,
      voiceSrc: ""
    };
  },

  methods: {
    handlePlayAudio(event) {
      const audioList = document.getElementsByTagName("audio");
      _.each(audioList, temp => {
        if (temp != this.audio) {
          temp.load();
        }
      });

      if (this.audio.paused) {
        this.audio.play();
        this.voiceTime = setInterval(this.changeVoiceNum, 300);
      } else {
        this.clearInterval();
        this.audio.pause();
      }

      this.audio.onended = () => {
        this.clearInterval();
      };
    },
    changeVoiceNum() {
      this.voiceNum++;
      if (this.voiceNum == 3) {
        this.voiceNum = 0;
      }
    },
    clearInterval() {
      clearInterval(this.voiceTime);
      this.voiceNum = 2;
    },

    dealVoiceParse() {
      VideoUpload.getVideoParseRoute(this.audioSrc).then(newUrl => {
        this.voiceSrc = newUrl;
      });
    },

    scrollEvent() {
      const el = this.$el;
      const rect = el.getBoundingClientRect();
      if (
        rect.top !== 0 &&
        rect.top < document.documentElement.clientHeight &&
        !this.voiceSrc
      ) {
        this.dealVoiceParse();
      }
    }
  },

  mounted() {
    this.audio = this.$refs.audio;
    let time = Math.floor(this.size / 1000);
    if (this.size / 1000 > 60) {
      const s = this.size / 1000;
      const second = Math.floor(s % 60);
      const minute = Math.floor(s / 60);
      time = `${minute}' ${second}`;
    }
    this.time = time;
    this.scrollEvent();
    if (document.querySelector(".comment-detail-scroll-page")) {
      document
        .querySelector(".comment-detail-scroll-page")
        .addEventListener(
          "scroll",
          window.throttle(this.scrollEvent.bind(this))
        );
    } else if (document.querySelector(".growth-index")) {
      document
        .querySelector(".growth-index")
        .addEventListener(
          "scroll",
          window.throttle(this.scrollEvent.bind(this))
        );
    } else {
      this.dealVoiceParse();
    }
  }
};
</script>

<style lang='less'>
.xm-audio {
  position: relative;
  height: 0.8rem;
  line-height: 0.8rem;
  background: #cceaff;
  border-radius: 0.1rem;
  max-width: 6rem;
  &:before {
    content: "";
    position: absolute;
    top: 0.2rem;
    left: -0.15rem;
    width: 0rem;
    height: 0rem;
    border-top: 0.2rem solid transparent;
    border-bottom: 0.2rem solid transparent;
    border-right: 0.3rem solid #cceaff;
    display: block;
  }
  .voice {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0.3rem;
    margin: auto;
    display: block;
    width: 0.2rem;
    height: 0.3rem;
  }
  .voice-time {
    margin-left: 0.9rem;
    color: #687885;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Audio.vue